import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let Monsters = class Monsters extends VuexModule {
    constructor() {
        super(...arguments);
        this.monsters = [];
        this.cachedVersion = 0;
    }
    async fetchMonsters() {
        const { data: monsters, cachedVersion } = await fetchFromCache(this, 'monsters', 'monster');
        return { monsters, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['monsters', 'cachedVersion'] })
], Monsters.prototype, "fetchMonsters", null);
Monsters = __decorate([
    Module({ namespaced: true, name: 'monsters' })
], Monsters);
export default Monsters;
